/**
 * FEMETRY — founder cards. Thumbnail "+" buttons swap the featured doctor
 * testimonial. Plain custom element, no build step.
 */
class FemetryFounderCards extends HTMLElement {
  connectedCallback() {
    this.quotes = [...this.querySelectorAll('.femetry-founders__quote')];
    this.thumbs = [...this.querySelectorAll('.femetry-founders__thumb')];
    this.thumbs.forEach((thumb) =>
      thumb.addEventListener('click', () => this.show(Number(thumb.dataset.index)))
    );
  }

  show(index) {
    this.quotes.forEach((q, i) => q.classList.toggle('is-active', i === index));
    this.thumbs.forEach((t, i) => {
      const active = i === index;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('femetry-founder-cards')) {
  customElements.define('femetry-founder-cards', FemetryFounderCards);
}
